import React from 'react'
import { Badge, TextStyle, Tippy } from '@superops/ui-design-system'
import { SVGIcon } from '@superops/super-icons'
import { FormattedMessage } from 'react-intl'
import { FEATURESTATE_ENUM } from './constant'

function FeatureLineItem ({ features, detailCard, plan, labelKey }) {
  return (
    <>
      <div className='fx uppercase my20 feature-group'>
        <TextStyle weight='Bold'>
          {detailCard ? (
            <FormattedMessage id={labelKey || 'app.common'} />
          ) : (
            <div />
          )}
        </TextStyle>
      </div>
      {features?.map((feat) => (
        <div className='feature-name'>
          {detailCard ? (
            <>
              <div
                className={`${
                  feat?.releaseState === FEATURESTATE_ENUM.UPCOMING
                    ? 'pinkText'
                    : ''
                } fx`}
              >
                <TextStyle>
                  <FormattedMessage
                    id={feat?.labelKey || feat?.title || 'app.common'}
                  />
                </TextStyle>
                {feat?.releaseState === FEATURESTATE_ENUM.UPCOMING && (
                  <div className='fx actr mlr5'>
                    <Tippy title='Coming soon' className='fximp'>
                      <SVGIcon color='#FF0055' size='sm' />
                    </Tippy>
                  </div>
                )}
                {feat?.releaseState === FEATURESTATE_ENUM.NEW_RELEASED && (
                  <div className='fx actr mlr5'>
                    <Badge status='success'>
                      <FormattedMessage id='changeLog.nav.new.header' />
                    </Badge>
                  </div>
                )}
                {feat?.releaseState === FEATURESTATE_ENUM.BETA && (
                  <div className='fx actr mlr5'>
                    <Badge status='info'>
                      <FormattedMessage id='common.beta' />
                    </Badge>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className='fx jctr actr availablity-icon'>
              {plan && <Availabity plan={plan} feat={feat} />}
            </div>
          )}
        </div>
      ))}
    </>
  )
}

const Availabity = ({ plan, feat }) => {
  const currentFeature = plan?.purchaseFeatures.find(
    (el) => el.feature.name === feat?.name
  )

  return (
    <SVGIcon
      color='#59DC7F'
      name={
        currentFeature?.available || currentFeature?.availableWithAddOn
          ? 'FeatureAvailable'
          : 'FeatureNotAvailable'
      }
    />
  )
}

export default FeatureLineItem
